var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":_vm.transitionName},on:{"before-enter":function($event){_vm.$parent.isTransitioning = true},"after-enter":function($event){_vm.$parent.isTransitioning = false}}},[(_vm.isActive)?_c('div',{staticClass:"flex-shrink-0"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }